import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "../../store";
import { getJobTypes } from "../../slices/jobType";
import { getSimpleUsers } from "../../slices/user";
import { Base } from "../base";
import { getJobStatuses } from "../../slices/jobStatus";
import ReportJobTable from "../views/Reports/ReportJobTable";
import { useNavigate } from "react-router-dom";

interface Props {}

const ReportsPage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loggedInUser } = useSelector((store) => store.authentication);

  useEffect(() => {
    dispatch(getJobTypes());
    dispatch(getJobStatuses());
    dispatch(getSimpleUsers(true));
  }, [dispatch]);

  useEffect(() => {
    if (!loggedInUser?.assignedJobTypes?.some((j) => j.logHours)) {
      navigate("/");
    }
  }, [loggedInUser?.assignedJobTypes, navigate]);

  return (
    <Box
      sx={{
        marginX: { md: 5, xs: 0 },
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <Base.TitleBar title="Reports" />
      <ReportJobTable />
    </Box>
  );
};

export default ReportsPage;
